import React from 'react'
import "./testimonials.css"
import AVTR1 from '../../assets/avatar1.jpg'
import AVTR2 from '../../assets/avatar2.jpg'
import AVTR3 from '../../assets/avatar3.jpg'
import AVTR4 from '../../assets/avatar4.jpg'

// import Swiper core and required modules
import { Navigation, Pagination} from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


const data = [
  {
    avatar: AVTR1,
    name: 'Tina Snow',
    review: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. A, qui perferendis sint cumque soluta voluptate laboriosam blanditiis,maiores, autem nostrum possimus. Laudantium iusto aliquid officiis fugiat! Iusto ut iure corrupti.'
  },
  {
    avatar: AVTR2,
    name: 'Shatter Wale',
    review: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. A, qui perferendis sint cumque soluta voluptate laboriosam blanditiis,maiores, autem nostrum possimus. Laudantium iusto aliquid officiis fugiat! Iusto ut iure corrupti.'
  },
  {
    avatar: AVTR3,
    name: 'Kwame Despite',
    review: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. A, qui perferendis sint cumque soluta voluptate laboriosam blanditiis,maiores, autem nostrum possimus. Laudantium iusto aliquid officiis fugiat! Iusto ut iure corrupti.'
  },
  {
    avatar: AVTR4,
    name: 'Shatter Wale',
    review: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. A, qui perferendis sint cumque soluta voluptate laboriosam blanditiis,maiores, autem nostrum possimus. Laudantium iusto aliquid officiis fugiat! Iusto ut iure corrupti.'
  },
]

const Testimonials = () => {
  return (
    <section id='testimonials'>
      <h5>References/Reviews from Clients</h5>
      <h2>Testimonials</h2>

      <Swiper className='container testimonials_container'
      // install Swiper modules
      modules={[Navigation, Pagination]}
      spaceBetween={40}
      slidesPerView={1}
      navigation
      pagination={{ clickable: true }}>
        {
          data.map(({avatar, name, review}, index) => {
            return (
              <SwiperSlide key={index} className="testimonial">
              <div className="client_avatar">
                <img src={avatar}/>
              </div>  
                <h5 className='client_name'>{name}</h5>
                <small className='client_review'>{review}</small>
            </SwiperSlide>
            )
          })
        }

      </Swiper>
    </section>
  )
}

export default Testimonials